module.exports = __webpack_public_path__ + "static/Criminal Investigation (Law, Practice & Procedure)-aa8089d7af38f6f50e85df2e377c423e.jpg";